import React from 'react';

import { Logger }       from 'aws-amplify';

import { Paper }        from '@material-ui/core';

import {
  ResourcesContext,
  ResourcePolyCard,
}                       from '../components/resource';

const logger = new Logger('Resource');

const Resource = ({ match }) => {

  const {
    params: { id },
  } = match;

  const { resources } = React.useContext(ResourcesContext);
  const resource = resources.find(r => r.ResourceId===id);

  if(!resource) {
    return(null);
  } else {
    logger.info("RESOURCE: ",resource);    
  }

  return(
    <ResourcePolyCard resource={resource} />
  );
};

export default Resource;

